module.exports = __webpack_public_path__ + "img/SKY.2114ed81.svg";